export const ru = {
  // NAV START
  'Home': 'ГЛАВНЫЙ',
  'Service' : 'Сервисы',
  'Contact' : 'Контакт',

  'HeroTitle' : 'inSITE Marketing -',
  'HeroTitleSec' : 'партнер для вашего надежного проекта',
  'HeroText' : 'Развивайте свой личный бренд вместе с нами. Мы заботимся о ваших целях, и усердно работаем вместе с нашей командой, чтобы предоставить вам лучшее качество. Команда «инСайт Маркетинг» очень благодарна за ваше доверие к нам.',
  'HeroBtn' : 'Подробно',

  'indicatorTitle' : 'Количество наших успешных работ',
  'indicatorTitle2' : 'ДОВОЛЬНЫЕ КЛИЕНТЫ',
  'indicatorTitle3' : 'ВИДЫ УСЛУГ',
  'indicatorTitle4' : 'НАШ ОПЫТ РАБОТЫ',
  'indicatorYear' : 'год',

  'serviceTitle' : 'Сервисы',
  'serviceType' : 'Веб-сайты',
  'serviceText' : 'Создайте свой сайт вместе с нами. Мы создаем разные типы сайтов по вашему желанию.',
  'serviceType2' : 'Google Реклама (SEO)',
  'serviceText2' : 'Мы профессионально прорекламируем ваш сайт в поисковых системах Google и Яндекс.',
  'serviceType3' : 'Телеграм-бот',
  'serviceText3' : 'Создайте своего Telegram-бота вместе с нами. Мы создаем разные типы ботов по вашему желанию.',
  'serviceType4' : 'Веб-дизайн',
  'serviceText4' : 'Веб-дизайн | Креативные и уникальные идеи для сайта',

  'advantagesTitle' : 'Наши преимущества',
  'advantagesType' : 'Опытные члены команды',
  'advantagesText' : 'Члены нашей команды являются профессионалами своего дела, имеют опыт работы в своей сфере более 1,5 лет и несут ответственность',
  'advantagesType2' : 'Техническая поддержка',
  'advantagesText2' : 'После завершения проекта наши сотрудники будут находиться под наблюдением в течение 3 месяцев',
  'advantagesType3' : 'Доступная цена и качество',
  'advantagesText3' : 'inSITEMARKETING предлагает своим клиентам отличное качество и доступные цены',
  'advantagesType4' : 'Гарантированное обслуживание',
  'advantagesText4' : 'Мы гарантируем 100%, что наша услуга будет соответствовать договоренности и мы предоставим ее в оговоренные сроки',
  'advantagesType5' : 'Профессиональный дизайн',
  'advantagesText5' : 'Мы профессионально подходим к дизайну, дизайн уникален и не является копией',
  'advantagesType6' : 'Креативные идеи',
  'advantagesText6' : 'Наша команда делится новыми идеями и предложениями в процессе сотрудничества',
 
  'accordionTitle' : 'Часто задаваемые вопросы',
  'accordionType' : 'Что нужно для создания сайта?',
  'accordionText1.1' : 'Для начала вам понадобится:',
  'accordionText1.2' : '— Логотип (если есть);',
  'accordionText1.3' : '— Концепт (фирменные цвета);',
  'accordionText1.4' : '— Контент для сайта (изображения, тексты, фото, видео и т.д.);',
  'accordionText1.5' : '— Ваши пожелания и требования;',
  'accordionType2' : 'Сколько времени занимает создание сайта?',
  'accordionText2' : 'Продолжительность создания полностью готовых сайтов может варьироваться и варьироваться в зависимости от типа проекта. Запуск самого простого сайта занимает 7 рабочих дней',
  'accordionType3' : 'Могу ли я изменить информацию на сайте самостоятельно?',
  'accordionText3' : 'Да, конечно, вам будут предоставлены инструкции и доступ к системе управления контентом, которая имеет очень удобный интерфейс, интуитивно понятный и не требующий специальных знаний.',
  'accordionType4' : 'Что входит в техническую поддержку?',
  'accordionText2.1' : 'Ежедневная резервная копия;',
  'accordionText2.2' : 'Установите новую версию;',
  'accordionText2.3' : 'Защита от вирусов;',
  'accordionText2.4' : 'Мониторинг;',
  'accordionText2.5' : 'Обновить информацию;',
  'accordionType5' : 'Будете ли вы оказывать техническую поддержку после завершения работы над сайтом?',
  'accordionText5' : 'Мы предоставляем БЕСПЛАТНУЮ техническую поддержку в течение 3 месяцев после подачи вашего сайта.',

  'contactToasterSend' : 'Ваше сообщение отправлено, мы свяжемся с вами в ближайшее время',
  'contactToasterUnSend' : 'Сообщение не отправлено! Пожалуйста, попробуйте еще раз😞',
  'contactTitle' : 'Связаться с нами',
  'contactRequest' : 'У вас есть вопрос?',
  'contactRequestText' : 'Затем заполните следующие разделы и отправьте нам. Мы ответим вам в ближайшее время!',
  'contactBtn' : 'Отправить',

  'footerServiceTitle' : 'Сервисы',
  'footerServiceLink' : 'Создать веб-сайт',
  'footerServiceLink2' : 'Телеграм-бот',
  'footerServiceLink3' : 'Веб-дизайн',
  'footerServiceLink4' : 'Реклама в Google и Яндексе',
  'footerAdvantagesTitle' : 'Наши преимущества',
  'footerAdvantagesLink' : 'Опытные члены команды',
  'footerAdvantagesLink2' : 'Техническая поддержка',
  'footerAdvantagesLink3' : 'Доступная цена и качество',
  'footerAdvantagesLink4' : 'Гарантированное обслуживание',
  'footerAdvantagesLink5' : 'Профессиональный дизайн',
  'footerAdvantagesLink6' : 'Креативные идеи',
  'footerContactPhone' : 'Связаться с нами',
  'footerLastText' : '© 2023 insitemarketing.uz Все права защищены',

  'servicePriceTitle' : 'Цены',
  'servicePriceLanding' : 'Ландинг паге',
  'servicePriceLandingBonus' : 'От нас к вам',
  'servicePriceLandingList1' : 'Домен',
  'servicePriceLandingList2' : 'Хостинг',
  'servicePriceLandingList3' : 'SSL-сертификат',
  'servicePriceLandingTime1' : 'Срок 3 дней',
  'servicePriceConsultation' : 'Бесплатная консультация',
  
  'servicePriceCatalog' : 'Сайт-каталог',
  'servicePriceCatalogTime2' : 'Срок 10/20 дней',
  'servicePriceCatalogPanel' : 'Панель администратора',

  'servicePriceMagasine' : 'Интернет-магазин',
  'servicePriceMagasineTime' : 'Срок 20/30 дней',
  'servicePriceMagasineXimoya' : 'Защита сайта',

  'servicePriceReklamaGoogle' : 'Google',
  'servicePriceReklamaList1' : 'Анализ ваших конкурентов',
  'servicePriceReklamaList2' : 'Анализ сайта + рекомендации',
  'servicePriceReklamaList3' : 'Оптимизация ставок и бюджета',
  'servicePriceReklamaList4' : 'Выбор ключевых слов',
  'servicePriceReklamaList5' : 'Оптимизация ставок и бюджета',
  'servicePriceReklamaList6' : 'Метрическое соединение',
  'servicePriceReklamaList7' : 'Еженедельный отчет',
  'servicePriceReklamaList8' : 'Время настройки: 5-7 дней',
  'servicePriceReklamaGoogleYandex2' : 'Время настройки: 7-10 дней',
  'servicePriceReklamaMonth' : 'в месяц',

  'servicePriceReklamaYandex' : 'Яндекс',
  'servicePriceReklamaGoogleYandex' : 'Google + Яндекс'

}